import React from "react";
import BgImage from "./BgImage";
import styled from 'styled-components';
import Img from 'gatsby-image';
import { device } from "../Theme";

const Regular = styled.div`
    display: block;

    @media ${device.mobileXL} { 
        display: none;
    }
`;
const Mobile = styled.div`
    display: none;
    
    @media ${device.mobileXL} { 
        display: block;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin-left: -5%;

    @media ${device.mobileXL} { 
        flex-direction: column;
        padding-bottom: 30px;
        margin: auto;
    }

    h1{
        font-size: 90px;
        @media ${device.mobile} { 
            font-size: 40px;
        }
        @media ${device.mobileXL} { 
            margin: -30px;
            padding: 0;
        }
    }
`;
const Image = styled.div`
    width: 150px;
    padding-top: 20px;
    
    @media ${device.mobile} { 
        width: 100px;
        padding-top: 13px;
    }
    @media ${device.mobileXL} { 
        margin: 0;
        padding: 0;
        width: 150px;
    }
`;

const Header = ({ data }) => (
    <>
        <Regular>
            <BgImage
                title={data.heroAlt}
                fluid={data.heroImage}
                height='400px'
            >
                <Container data-sal="fade" data-sal-easing="ease-in-circ">
                    <Image>
                        <Img
                            fluid={data.heroLogo}
                            alt={data.heroAltLogo}
                        />
                    </Image>
                    <h1>{data.title}</h1>
                </Container>
            </BgImage>
        </Regular>
        <Mobile>
            <BgImage
                title={data.heroAltMobile}
                fluid={data.heroMobile}
                mobileHeight='300px'
            >
                <Container data-sal="fade" data-sal-easing="ease-in-circ">
                    <Image>
                        <Img
                            fluid={data.heroLogo}
                            alt={data.heroAltLogo}
                        />
                    </Image>
                    <h1>{data.title}</h1>
                </Container>
            </BgImage>
        </Mobile>
    </>
);
export default Header;